import React, { Component } from 'react';
import Navbar from '../components/Layouts/Navbar';
import SubscribeStyleOne from '../components/Common/SubscribeStyleOne';
import SoftwareDevelopmentMainBanner from '../components/SoftwareDevelopment/SoftwareDevelopmentMainBanner';
import SoftwareDevelopmentEigenschaften from '../components/SoftwareDevelopment/SoftwareDevelopmentEigenschaften';
import SoftwareDevelopmentTechnologies from '../components/SoftwareDevelopment/SoftwareDevelopmentTechnologies';
import SoftwareDevelopmentProcess from '../components/SoftwareDevelopment/SoftwareDevelopmentProcess';
import SoftwareDevelopmentInfoAndCTA from '../components/SoftwareDevelopment/SoftwareDevelopmentInfoAndCTA';
import SoftwareDevelopmentFAQ from '../components/SoftwareDevelopment/SoftwareDevelopmentFAQ';
import SoftwareDevelopmentWeitereDienstleistungen from '../components/SoftwareDevelopment/SoftwareDevelopmentWeitereDienstleistungen';
import Footer from '../components/Layouts/Footer';
import PageSeo from '../components/Common/PageSeo';
import { useTranslations } from "../locales/useTranslations";
import { useRouter } from 'next/router';

const SoftwareDevelopment = () => {
    const { t } = useTranslations();
    const { locale } = useRouter();
    const baseUrl = locale === 'en' ? 'https://simplify-data.com' : 'https://simplify-data.de';
    return (
        <>
            <PageSeo
                title={t('softwareDevelopment_page_title')}
                description={t('softwareDevelopment_page_description')}
                canonical={`${baseUrl}/software-development/`}
                openGraph={{
                    url: `${baseUrl}/software-development/`,
                    title: t('softwareDevelopment_page_ogTitle'),
                    description: t('softwareDevelopment_page_ogDescription'),
                    images: [
                        {
                            url: `${baseUrl}/images/simplify-data.png`,
                            width: 1080,
                            height: 1080,
                            alt: t('softwareDevelopment_page_ogImageAlt'),
                            type: 'image/jpeg',
                        },
                    ],
                    siteName: t('softwareDevelopment_page_title'),
                    locale: 'de_DE',
                    type: 'website'
                }}
                twitter={{
                    handle: '@simplify_data',
                    site: '@simplify_data',
                    cardType: 'summary_large_image',
                }}
                additionalMetaTags={[
                    {
                        name: 'robots',
                        content: 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1',
                    },
                    {
                        name: 'keywords',
                        content: t('softwareDevelopment_page_keywords')
                    },
                    {
                        name: 'author',
                        content: 'Simplify Data'
                    },
                    {
                        name: 'geo.region',
                        content: 'DE-SH'
                    },
                    {
                        name: 'geo.placename',
                        content: 'Kiel'
                    },
                    {
                        property: 'article:modified_time',
                        content: new Date().toISOString()
                    },
                    {
                        name: 'format-detection',
                        content: 'telephone=no'
                    }
                ]}
                additionalLinkTags={[
                    {
                        rel: 'icon',
                        href: `${baseUrl}/images/favicon.png`,
                        type: 'image/png'
                    },
                    {
                        rel: 'alternate',
                        hrefLang: 'de',
                        href: 'https://simplify-data.de/software-development/'
                    },
                    {
                        rel: 'alternate',
                        hrefLang: 'en',
                        href: 'https://simplify-data.com/software-development/'
                    }
                ]}
            />

            <Navbar />
            <SoftwareDevelopmentMainBanner />
            <SoftwareDevelopmentEigenschaften />
            <SoftwareDevelopmentTechnologies />
            <SoftwareDevelopmentProcess />
            <SoftwareDevelopmentInfoAndCTA />
            <SoftwareDevelopmentFAQ />
            <SoftwareDevelopmentWeitereDienstleistungen />

            <SubscribeStyleOne />
            <Footer />
        </>
    );
}

export default SoftwareDevelopment;